import {useEffect} from 'react'

import NumberInput from '../../../../common/components/Form/NumberInput.js'
import Quantity from '../../../../common/components/Quantity.js'
import {
  getProductForInventoryTransferCreate,
  removeSKUFromCreateInventoryTransfer,
  setCreateInventoryTransferModalRowForm,
  updateCreateInventoryTransferModalRowForm,
  removeCreateInventoryTransferModalRowForm,
  createInventoryTransferModalRowFormSelector,
  errorsSelector,
  warningsSelector,
  sendingWarehouseIDSelector,
  receivingWarehouseIDSelector,
} from './createInventoryTransferModalFunctions.js'
import {
  productSelector,
  productWarehouseSelector,
} from '../../../../data/products.js'
import {isNumeric} from '../../../../common/utils.js'
import Icon from '../../../../common/icons/Icon.js'
import {useSelector} from '../../../../store.js'

export default function ProductRow({sku, autoFocus}) {
  const sending_warehouse_id = useSelector(sendingWarehouseIDSelector)
  const receiving_warehouse_id = useSelector(receivingWarehouseIDSelector)
  const product = useSelector((state) => productSelector(state, {sku}))
  const fromWarehouseInventory = useSelector((state) =>
    productWarehouseSelector(state, {
      sku,
      warehouseID: sending_warehouse_id,
    }),
  )
  const toWarehouseInventory = useSelector((state) =>
    productWarehouseSelector(state, {
      sku,
      warehouseID: receiving_warehouse_id,
    }),
  )
  const row = useSelector((state) =>
    createInventoryTransferModalRowFormSelector(state, {sku}),
  )
  const errors = useSelector((state) => errorsSelector(state, {sku}))
  const warnings = useSelector((state) => warningsSelector(state, {sku}))

  useEffect(() => {
    setCreateInventoryTransferModalRowForm(sku, {
      quantity: '1',
      line_notes: '',
      serverError: null,
    })

    return () => removeCreateInventoryTransferModalRowForm(sku)
  }, [])

  useEffect(() => {
    if (!product && !(row && row.serverError)) {
      getProductForInventoryTransferCreate(sku)
    }
  }, [product, row])

  if (!row) {
    return null
  }

  const deleteRow = (
    <td className="table__td align-right">
      <button
        type="button"
        className="btn btn--link no-underline"
        onClick={() => removeSKUFromCreateInventoryTransfer(sku)}
      >
        <Icon name="trash" className="fs-00" />
      </button>
    </td>
  )

  if (row.serverError) {
    return (
      <tr>
        <td className="table__td" colSpan="7">
          {row.serverError}
        </td>
        {deleteRow}
      </tr>
    )
  }

  if (!product) {
    return (
      <tr>
        <td className="table__td" colSpan="7">
          Loading...
        </td>
        {deleteRow}
      </tr>
    )
  }

  const {name} = product

  const fromPOH =
    fromWarehouseInventory &&
    fromWarehouseInventory.physical_on_hand - Number(row.quantity)
  const toPOH =
    toWarehouseInventory &&
    toWarehouseInventory.physical_on_hand + Number(row.quantity)

  return (
    <tr>
      <td className="table__td">
        <strong className="word-breaker">{name}</strong>
        <div className="word-breaker">{sku}</div>
        {errors.product && (
          <div className="fs-n2 error error-message align-center margin-top-5">
            {errors.product}
          </div>
        )}
      </td>
      <td className="table__td align-center">
        <strong>
          {fromWarehouseInventory ? (
            <Quantity value={fromWarehouseInventory.committed} />
          ) : (
            '—'
          )}
        </strong>
      </td>
      <td className="table__td align-center">
        <strong>
          {isNumeric(fromPOH) ? <Quantity value={fromPOH} /> : '—'}
        </strong>
      </td>
      <td className="table__td">
        <div className="flex--center">
          <NumberInput
            id="id_product_quantity"
            value={row.quantity}
            onChange={(value) =>
              updateCreateInventoryTransferModalRowForm(sku, {
                quantity: value,
              })
            }
            onIncrement={(value) =>
              updateCreateInventoryTransferModalRowForm(sku, {
                quantity: value,
              })
            }
            onDecrement={(value) =>
              updateCreateInventoryTransferModalRowForm(sku, {
                quantity: value,
              })
            }
            isInvalid={!!errors.quantity}
            min={0}
            autoFocus={autoFocus}
          />
        </div>
        {errors.quantity && (
          <div className="fs-n2 error error-message align-center margin-top-5">
            {errors.quantity}
          </div>
        )}
        {warnings.quantity && (
          <div className="fs-n2 text--warning align-center margin-top-5">
            {warnings.quantity}
          </div>
        )}
      </td>
      <td className="table__td align-center">
        <strong>
          {toWarehouseInventory ? (
            <Quantity value={toWarehouseInventory.committed} />
          ) : (
            '—'
          )}
        </strong>
      </td>
      <td className="table__td align-center">
        <strong>{isNumeric(toPOH) ? <Quantity value={toPOH} /> : '—'}</strong>
      </td>
      <td className="table__td">
        <div className="relative">
          <input
            type="text"
            className="input--text input--med-h margin-bottom-0"
            value={row.line_notes}
            onChange={(event) => {
              updateCreateInventoryTransferModalRowForm(sku, {
                line_notes: event.target.value,
              })
            }}
          />
        </div>
        {errors.line_notes && (
          <div className="fs-n2 error error-message align-center margin-top-5">
            {errors.line_notes}
          </div>
        )}
      </td>
      {deleteRow}
    </tr>
  )
}
